import React from "react";
import { blankMaskStyle } from "../../styles/commonStyles";

export default function MaskedInputPlaceholder() {
  return (
    <div style={{ display: "grid", gap: "0.75rem", marginTop: "1rem" }}>
      <div style={blankMaskStyle()} />
      <div style={blankMaskStyle()} />
    </div>
  );
}